
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Card = makeShortcode("Card");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Card mdxType="Card">
      <h1>{`นโยบายความเป็นส่วนตัว`}</h1>
      <hr></hr>
      <h2>{`นโยบายคุ้มครองข้อมูลส่วนบุคคลของเว็บไซต์ค่ายลานเกียร์`}</h2>
      <p>{`เว็บไซต์ค่ายลานเกียร์เป็นเว็บไซต์ที่ใช้และประมวลผลข้อมูลส่วนบุคคลของผู้ใช้บริการ เพื่อวัตถุประสงค์หลายประการ เช่น การพัฒนาเว็บไซต์และการคัดเลือกผู้เข้าร่วมค่าย`}</p>
      <p>{`เราตระหนักถึงความสำคัญของการจัดการและคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้ และจะปฏิบัติตามกฎหมายที่เกี่ยวข้องทั้งหมด รวมถึงทำงานเพื่อจัดการและคุ้มครองข้อมูลอย่างเหมาะสมตามนโยบายนี้`}</p>
      <hr></hr>
      <h2>{`คำนิยาม`}</h2>
      <ul>
        <li parentName="ul"><strong parentName="li">{`"เรา"`}</strong>{` หมายถึง ทีมผู้พัฒนาเว็บไซต์ค่ายลานเกียร์และทีมงานที่เกี่ยวข้องทุกคน`}</li>
        <li parentName="ul"><strong parentName="li">{`"ผู้ใช้" หรือ "คุณ"`}</strong>{` หมายถึง ผู้ที่เข้ามาใช้บริการเว็บไซต์ค่ายลานเกียร์ รวมถึงผู้สมัครเข้าค่ายทุกคน`}</li>
        <li parentName="ul"><strong parentName="li">{`"ข้อมูลส่วนบุคคล"`}</strong>{` หมายถึง ข้อมูลส่วนบุคคลตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 ("พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล")`}</li>
        <li parentName="ul"><strong parentName="li">{`"เก็บรวบรวม" และ "ใช้"`}</strong>{` หมายถึง "การประมวลผล" ตามที่กำหนดไว้ใน พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล ซึ่งรวมถึงการรวบรวม บันทึก และเปิดเผย`}</li>
      </ul>
      <p>{`เราจะเก็บรวบรวม ใช้ เก็บรักษา และแบ่งปันข้อมูลส่วนบุคคลประเภทต่างๆ ของผู้ใช้ เช่น:`}</p>
      <ul>
        <li parentName="ul"><strong parentName="li">{`ข้อมูลที่ระบุตัวตน หรือข้อมูลสำหรับการติดต่อ:`}</strong>{` ชื่อ, ที่อยู่, อีเมล, เบอร์โทรศัพท์, หมายเลขบัตรประชาชน, ชื่อผู้ใช้`}</li>
        <li parentName="ul"><strong parentName="li">{`ข้อมูลการใช้งาน:`}</strong>{` วิธีการใช้เว็บไซต์และบริการของเรา, ข้อเสนอแนะเกี่ยวกับประสบการณ์การใช้บริการ`}</li>
      </ul>
      <hr></hr>
      <h2>{`การใช้ข้อมูลส่วนบุคคล`}</h2>
      <p>{`เว็บไซต์ค่ายลานเกียร์จะใช้ข้อมูลส่วนบุคคลของผู้ใช้ตามวัตถุประสงค์ที่ได้แจ้งไว้ และจะไม่นำไปใช้เพื่อวัตถุประสงค์อื่น เว้นแต่จะได้รับความยินยอมหรือเป็นไปตามที่กฎหมายกำหนด`}</p>
      <p><strong parentName="p">{`วัตถุประสงค์ในการใช้ข้อมูล:`}</strong></p>
      <ul>
        <li parentName="ul">{`เพื่อแนะแนวการศึกษาต่อในคณะวิศวกรรมศาสตร์`}</li>
        <li parentName="ul">{`เพื่อเสริมสร้างทักษะการทำงานร่วมกันให้กับสมาชิกชมรม`}</li>
        <li parentName="ul">{`เพื่อเพิ่มช่องทางในการเข้าถึงข้อมูลเกี่ยวกับคณะวิศวกรรมศาสตร์`}</li>
        <li parentName="ul">{`เพื่อปฏิบัติตามข้อผูกพันและข้อตกลง`}</li>
        <li parentName="ul">{`เพื่อการประเมินผลค่ายลานเกียร์`}</li>
        <li parentName="ul">{`วัตถุประสงค์อื่นที่อาจเพิ่มเติมในอนาคต (จะมีการแจ้งให้ทราบ)`}</li>
      </ul>
      <p><strong parentName="p">{`ประเภทข้อมูลที่เราเก็บจากผู้ใช้:`}</strong></p>
      <ul>
        <li parentName="ul"><strong parentName="li">{`ข้อมูลระบุตัวตน:`}</strong>{` ชื่อ, หมายเลขบัตรประชาชน, รูปถ่าย`}</li>
        <li parentName="ul"><strong parentName="li">{`ข้อมูลติดต่อ:`}</strong>{` เบอร์โทร, ที่อยู่, อีเมล`}</li>
        <li parentName="ul"><strong parentName="li">{`ข้อมูลการศึกษา:`}</strong>{` ปพ.1, ปพ.7`}</li>
      </ul>
      <p>{`การให้ข้อมูลส่วนบุคคลเป็นไปโดยสมัครใจ หากไม่ให้ข้อมูลอาจทำให้เว็บไซต์ไม่สามารถให้บริการได้อย่างสมบูรณ์ หากต้องการลบข้อมูลสามารถติดต่อผ่าน Facebook Page: `}<strong parentName="p">{`LarnGear Camp`}</strong></p>
      <p><strong parentName="p">{`การจัดเก็บและความปลอดภัยของข้อมูล`}</strong></p>
      <p>{`ข้อมูลของคุณจะถูกจัดเก็บอย่างปลอดภัยภายใต้การควบคุมของผู้มีหน้าที่เกี่ยวข้องเท่านั้น`}</p>
      <ul>
        <li parentName="ul">{`เราจะไม่เปิดเผยข้อมูลของคุณให้แก่บุคคลภายนอก`}</li>
        <li parentName="ul">{`เราจะไม่นำข้อมูลของคุณไปใช้ในเชิงพาณิชย์ หรือส่งต่อเพื่อประโยชน์อื่นใดที่ไม่เกี่ยวข้องกับกิจกรรมในค่าย`}</li>
        <li parentName="ul">{`จะเก็บไว้เท่าที่จำเป็น (เช่น ไม่เกิน 1 ปีหลังจบการสมัคร หรือจนกว่าความสัมพันธ์จะสิ้นสุด) เมื่อครบกำหนดจะลบหรือทำให้เป็นนิรนาม เว้นแต่จำเป็นต้องเก็บเพื่อภาระผูกพันทางกฎหมาย`}</li>
      </ul>
      <p><strong parentName="p">{`สิทธิของผู้ใช้`}</strong></p>
      <p>{`ผู้ใช้มีสิทธิในการ:`}</p>
      <ul>
        <li parentName="ul">{`เพิกถอนความยินยอม`}</li>
        <li parentName="ul">{`เข้าถึงข้อมูลส่วนบุคคล`}</li>
        <li parentName="ul">{`แก้ไขข้อมูล`}</li>
        <li parentName="ul">{`ลบข้อมูล`}</li>
      </ul>
      <hr></hr>
      <h3>{`การให้ความยินยอม`}</h3>
      <p>{`เมื่อคุณได้อ่านและเข้าใจข้อความโดยละเอียดแล้ว การกดส่งแบบฟอร์มถือว่าคุณได้รับทราบและยินยอมตามข้อกำหนดข้างต้น`}</p>
      <hr></hr>
      <h2>{`การทบทวนและปรับปรุงนโยบาย`}</h2>
      <p>{`นโยบายนี้อาจมีการเปลี่ยนแปลงโดยไม่แจ้งล่วงหน้า ผู้ใช้ควรเยี่ยมชมเว็บไซต์เพื่ออ่านนโยบายล่าสุด`}</p>
    </Card>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;